interface ReplyIconProps {
  size?: number;
  className?: string;
  filled?: boolean;
  turnToRight?: boolean;
}

const ReplyIcon = ({
  size = 36,
  className = '',
  filled = false,
  turnToRight = false
}: ReplyIconProps) => {
  const mirrorStyle = turnToRight ? { transform: 'scaleX(-1)' } : {};

  if (filled) {
    return (
      <span className={className}>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width={size}
          height={size}
          viewBox='0 0 12 12'
          fill='none'
          style={mirrorStyle}
        >
          <path
            d='M0 4.5853V4.60013C0.00417709 4.79375 0.0829773 4.97831 0.21868 5.11273L4.01693 8.8622C4.11575 8.95893 4.24598 9.01264 4.3801 9.01264C4.40862 9.01264 4.43729 9.00997 4.46567 9.00537C4.71273 8.96279 4.89683 8.74722 4.90476 8.4898L4.96483 6.63569C7.72312 6.79474 11.6978 8.20761 11.1393 11.7737C11.0947 12.0584 11.2469 12.0747 11.3626 11.8212C13.5602 7.0115 9.75405 2.70389 4.8529 2.37585L4.73563 0.501712C4.72728 0.372932 4.67527 0.255576 4.59417 0.167596C4.51277 0.0791703 4.40286 0.0192311 4.27781 0.00394953C4.11532 -0.0165248 3.9534 0.0434145 3.83945 0.164925L0.197504 4.07952C0.0703001 4.21542 0.000144005 4.39687 0.000144005 4.5853H0Z'
            fill='currentColor'
          />
        </svg>
      </span>
    );
  }

  return (
    <span className={className}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 20 21'
        style={mirrorStyle}
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.72531 3.31018C8.35644 2.65228 9.44818 3.11039 9.44818 4.03313V6.5216C11.9378 6.77092 14.2918 7.69079 16.1572 9.35669C18.2308 11.2085 19.642 13.9304 19.9938 17.5121C20.1005 18.5989 18.8127 18.9865 18.2239 18.2819C17.0248 16.8468 15.6752 15.94 14.1624 15.4791C12.7808 15.0581 11.2192 14.9959 9.45075 15.2948V17.8002C9.45075 18.7228 8.35918 19.181 7.728 18.5233L1.12213 11.6397C0.737131 11.2385 0.737072 10.5949 1.12201 10.1936L7.72531 3.31018ZM8.5822 8.18175C8.13198 8.16534 7.7719 7.78601 7.7719 7.32046V5.7124L2.77962 10.9165L7.77446 16.1214V14.7212C7.77446 14.2292 8.11398 13.807 8.58246 13.7108C10.7704 13.2618 12.7954 13.2699 14.6399 13.8319C15.8508 14.2008 16.9612 14.8016 17.9727 15.6375C17.4235 13.4816 16.3842 11.8384 15.0561 10.6524C13.3275 9.10866 11.0509 8.2878 8.5822 8.18175Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
};

export default ReplyIcon;
